import { Send, CalendarClock, X } from 'lucide-react';
import { Button } from '@jeraisonne/ui';

interface BulkBarProps {
  count: number;
  pending: boolean;
  onPublishNow: () => void;
  onSchedule: () => void;
  onClear: () => void;
}

/** Barre d'actions groupées — visible dès qu'au moins une diffusion est cochée. */
export function DiffusionsBulkBar({
  count,
  pending,
  onPublishNow,
  onSchedule,
  onClear,
}: BulkBarProps) {
  return (
    <div className="border-ink-200 fixed inset-x-0 bottom-0 z-30 border-t bg-white/95 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur md:left-60">
      <div className="mx-auto flex max-w-4xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center justify-between gap-2">
          <p className="font-display text-ink-900 text-sm font-bold">
            {count} sélectionnée{count > 1 ? 's' : ''}
          </p>
          <button
            onClick={onClear}
            className="text-ink-500 hover:text-ink-900 inline-flex items-center gap-1 font-sans text-xs sm:hidden"
          >
            <X className="h-3.5 w-3.5" /> Effacer
          </button>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onSchedule}
            disabled={pending}
            className="flex-1 sm:flex-none"
          >
            <CalendarClock className="h-4 w-4" /> Programmer
          </Button>
          <Button
            size="sm"
            onClick={onPublishNow}
            loading={pending}
            disabled={pending}
            className="flex-1 sm:flex-none"
          >
            <Send className="h-4 w-4" /> Publier maintenant
          </Button>
          <button
            onClick={onClear}
            className="text-ink-500 hover:text-ink-900 hidden items-center gap-1 font-sans text-xs sm:inline-flex"
          >
            <X className="h-3.5 w-3.5" /> Effacer
          </button>
        </div>
      </div>
    </div>
  );
}
